import apiClient from './api';

export interface TranslationTask {
    task_id: string;
    status: 'pending' | 'translating' | 'completed' | 'failed';
    source_filename: string;
    file_format: string;
    target_language: string;
    error_message?: string;
    result_filename?: string;
    download_url?: string;
    created_at: string;
    started_at?: string;
    completed_at?: string;
}

export interface Language {
    code: string;
    name: string;
}

export interface TaskListResponse {
    items: TranslationTask[];
    total: number;
    page: number;
    page_size: number;
}

export const translationApi = {
    translateQuick: async (file: File, targetLanguage: string): Promise<TranslationTask> => {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('target_language', targetLanguage);

        const response = await apiClient.post<{ task_id: string; status: string }>('/api/v1/translate/quick', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            timeout: 300000, // 5 minutes since translation can take time
        });

        return response.data as TranslationTask;
    },

    getTaskStatus: async (taskId: string): Promise<TranslationTask> => {
        const response = await apiClient.get(`/api/v1/translate/${taskId}`);
        return response.data;
    },

    getLanguages: async (): Promise<Language[]> => {
        const response = await apiClient.get('/api/v1/translate/languages');
        return response.data.languages;
    },

    getTasks: async (page = 1, pageSize = 20, status?: string): Promise<TaskListResponse> => {
        const params: any = { page, page_size: pageSize };
        if (status) params.status = status;

        const response = await apiClient.get('/api/v1/translate/tasks', { params });
        return response.data;
    },

    deleteTask: async (taskId: string): Promise<void> => {
        await apiClient.delete(`/api/v1/translate/${taskId}`);
    },
};
